import { Config } from '@/config';
import apiService from '@/services/api.service';
import type { DTOPage } from '@/store/page.interface';

class PagesService {
  async getPage(pageId: number): Promise<DTOPage | null> {
    try {
      const response = await apiService.get<DTOPage>(`${Config.api.backend.urlV2}/pages/${pageId}`);
      return response.data ?? null;
    } catch (error) {
      console.error('Failed to load page by id:', error);
      return null;
    }
  }

  async getPageBySlug(slug: string): Promise<DTOPage | null> {
    try {
      const response = await apiService.get<DTOPage>(`${Config.api.backend.urlV2}/pages/slug:${slug}`);
      return response.data ?? null;
    } catch (error) {
      console.error('Failed to load page by slug:', error);
      return null;
    }
  }
}

export const pagesService = new PagesService();
